import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onTickerAnimationEnd: PlayUIListenerCreator = (
  services: IServices
) => () => {
  // tslint:disable-next-line:no-empty
};
